<div class="modal" id="transactionDetailModal" tabindex="-1" role="dialog" aria-hidden="true" data-backdrop="static">
  <div class="modal-dialog modal-md modal-dialog-scrollable modal-dialog-centered" role="document">
    <div class="modal-content">
      <div class="modal-header popup-header">
        <h5 class="modal-title" id="transactionDetailTitle" style="line-height: 20px;">
          Transactions
        </h5>
        <button type="button" id="closeTransactionDetailModal" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="hide-x-scroll modal-body">
        <div class="container card mb-2" *ngFor="let transaction of transactions">
          <div class="row p-2">
            <div class="col-6 p-0">
              <span class="font13-600">Initiated Date: </span>
              <span class="font13-400">{{transaction.initiatedDate | date: 'MM/dd/yyyy' : 'Z'}}</span>
            </div>
            <div class="col-6 p-0">
              <span class="font13-600">Status: </span>
              <span class="font13-400">{{transaction.status}}</span>
            </div>
            <div class="col-6 p-0">
              <span class="font13-600">Completed Date: </span>
              <span class="font13-400">{{transaction.completedDate | date: 'MM/dd/yyyy' : 'Z'}}</span>
            </div>
            <div class="col-6 p-0">
              <span class="font13-600">Amount: </span>
              <span class="font13-400">{{transaction.amount | number : '1.2-2'}} ({{invoice.invoiceSummary.currency}})</span>
            </div>
            <div class="col-6 p-0">
              <span class="font13-600">Transaction Type: </span>
              <span class="font13-400">{{transaction.transactionType}}</span>
            </div>
            <div class="col-6 p-0">
              <span class="font13-600">Mode: </span>
              <span class="font13-400">{{transaction.mode}}</span>
            </div>
            <div class="col-12 p-0">
              <span class="font13-600">Transaction Id: </span>
              <span class="font13-400">{{transaction.transactionId}}</span>
            </div>
          </div>
        </div>
        <!-- <div class="table-responsive">
          <table class="table table-striped">
            <thead class="thead-light">
              <tr>
                <th scope="col">Transaction Id</th>
                <th scope="col">Initiated Date</th>
                <th scope="col">Completed Date</th>
                <th scope="col" class="text-center">Amount ({{invoice.invoiceSummary.currency}})</th>
                <th scope="col">Transaction Type</th>
                <th scope="col">Mode</th>
                <th scope="col" class="text-right">Status</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let transaction of transactions">
                <td>
                  <span>{{transaction.transactionId}}</span>
                </td>
                <td>
                  <span>{{transaction.initiatedDate | date: 'MM/dd/yyyy' : 'Z'}}</span>
                </td>
                <td>
                  <span>{{transaction.completedDate | date: 'MM/dd/yyyy' : 'Z'}}</span>
                </td>
                <td class="text-center">
                  <span>{{transaction.amount | number : '1.2-2'}}</span>
                </td>
                <td>
                  <span>{{transaction.transactionType}}</span>
                </td>
                <td>
                  <span>{{transaction.mode}}</span>
                </td>
                <td class="text-right">
                  <span>{{transaction.status}}</span>
                </td>
              </tr>
            </tbody>
          </table>
        </div> -->
        <!-- <div class="table-responsive">
          <table class="table table-striped">
            <tbody>
              <ng-container *ngFor="let transaction of transactions">
                <tr>
                  <th width="35%" scope="col">Initiated Date</th>
                  <th width="25%" scope="col">Amount ({{invoice.invoiceSummary.currency}})</th>
                  <th width="40%" scope="col" class="text-right">Status</th>
                </tr>
                <tr>
                  <td>
                    <span>{{transaction.initiatedDate | date: 'MM/dd/yyyy' : 'Z'}}</span>
                  </td>
                  <td>
                    <span>{{transaction.amount | number : '1.2-2'}}</span>
                  </td>
                  <td class="text-right">
                    <span>{{transaction.status}}</span>
                  </td>
                </tr>
                <tr>
                  <th width="35%" scope="col">Transaction Type</th>
                  <th width="25%" scope="col">Mode</th>
                  <th width="40%" scope="col" class="text-right">Transaction Id</th>
                </tr>
                <tr>
                  <td>
                    <span>{{transaction.transactionType}}</span>
                  </td>
                  <td>
                    <span>{{transaction.mode}}</span>
                  </td>
                  <td class="text-right">
                    <span>{{transaction.transactionId}}</span>
                  </td>
                </tr><br><br>
              </ng-container>
            </tbody>
          </table>
        </div> -->
      </div>
    </div>
  </div>
</div>